import React, { createContext } from 'react';

import { IdentityProvider } from '../../context';

import { NewPOAProvider } from '.';

export const NewPOAContext = createContext(null);

export function NewPOAComposer() {
  return (
    <IdentityProvider>
      <NewPOAProvider />
    </IdentityProvider>
  );
}
